export default __webpack_public_path__ + "static/media/luggage.7e12384d.svg";